<template>
  <div>
    <b-row>
      <b-col>
        <b-card class="header-marcar_consulta bg-gradient-primary">
          <b-row align-v="center">
            <b-col lg="6">
              <h1>
                <feather-icon icon="CalendarIcon" size="30" class="mr-50" />
                Semanas Epidemiológicas
              </h1>
            </b-col>
            <b-col lg="6" class="text-right">
              <b-button
                variant="warning"
                :to="'/SemanaEpidemiologica/cadastrar'"
              >
                Nova Semana</b-button
              >
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-card no-body class="mb-0">
      <b-table
        ref="refSemanaListTable"
        class="position-relative"
        :items="fetchedSemanas.content"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        empty-text="Nenhuma semana epidemiológica cadastrada"
      >
        <template #cell(dataInicio)="data">
          {{ formatDate(data.item.dataInicio) }}
        </template>
        <template #cell(dataFim)="data">
          {{ formatDate(data.item.dataFim) }}
        </template>

        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              :to="{ name: 'SemanaEpidemiologicaEditar', params: { id: data.item.id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>
            <b-dropdown-item
              @click="confirmDelete(data.item.id)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Excluir</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      
      <div class="mx-2 mb-2 mt-1">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ fetchedSemanas.content ? fetchedSemanas.content.length : 0 }} de {{ fetchedSemanas.totalItems || 0 }} registros</span>
          </b-col>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="fetchedSemanas.totalItems || 0"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="fetchSemanas"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import semanaEpidemiologicaService from '@/services/semanaEpidemiologicaService'
import { hideSpinner, showSpinner } from '@/services/spinService'
import {
  BRow, BCol, BCard, BButton, BTable, BDropdown, BDropdownItem, BPagination
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow, BCol, BCard, BButton, BTable, BDropdown, BDropdownItem, BPagination
  },
  data: () => ({
    currentPage: 1,
    perPage: 10,
    fetchedSemanas: { content: [], totalItems: 0 },
    tableColumns: [
      { key: 'descricao', label: 'Descrição', sortable: true },
      { key: 'dataInicio', label: 'Data Início', sortable: true },
      { key: 'dataFim', label: 'Data Fim', sortable: true },
      { key: 'actions', label: 'Ações' },
    ],
  }),
  mounted() {
    this.fetchSemanas()
  },
  methods: {
    formatDate(date) {
      if (!date) return '-'
      if (typeof date === 'string') {
        const datePart = date.split('T')[0]
        const parts = datePart.split('-')
        if (parts.length === 3) {
          return `${parts[2]}/${parts[1]}/${parts[0]}`
        }
      }
      try {
        const d = new Date(date)
        if (isNaN(d.getTime())) return '-'
        const day = String(d.getUTCDate()).padStart(2, '0')
        const month = String(d.getUTCMonth() + 1).padStart(2, '0')
        const year = d.getUTCFullYear()
        return `${day}/${month}/${year}`
      } catch (e) {
        return '-'
      }
    },
    async fetchSemanas() {
      showSpinner()
      try {
        const response = await semanaEpidemiologicaService.getAll({
          page: this.currentPage,
          itemsPerPage: this.perPage,
        })
        this.fetchedSemanas = response
      } catch (error) {
        console.error(error)
      } finally {
        hideSpinner()
      }
    },
    async confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja excluir esta semana epidemiológica?', {
          title: 'Confirmar Exclusão',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim, excluir',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.deleteSemana(id)
          }
        })
    },
    async deleteSemana(id) {
      showSpinner()
      try {
        await semanaEpidemiologicaService.delete(id)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Excluído com sucesso',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.fetchSemanas()
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao excluir',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        hideSpinner()
      }
    }
  }
}
</script>
